import { render, staticRenderFns } from "./clone_wiki_modal.vue?vue&type=template&id=35ab7c08"
import script from "./clone_wiki_modal.vue?vue&type=script&lang=js"
export * from "./clone_wiki_modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports